import React, { useCallback, useEffect, useState } from "react";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import EventBus from "../../EventBus";
import DeniedCookInterface from "../../interfaces/Cook/DeniedCookInterface";
import { OneMealService } from "../../services/OneMealService";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import DeniedCooks from "../Common/DeniedCooks";
import EmptyListPlaceholder from "../Common/EmptyListPlaceholder";
import { moduleType } from "../../enums/common";
import ChefForPartyService from "../../services/ChefForPartyService";

const omsService = new OneMealService();
const chefForPartyService = new ChefForPartyService();

interface InputProps {
  serviceId: number;
  type?: moduleType
}

const OmsDeniedCookList = (props: InputProps) => {
  const [deniedCooksInOms, setDeniedCookSInOms] = useState<
    DeniedCookInterface[]
  >([]);

  const revertDeniedCook = (trialId: number, cookId: number) => {
    if(props?.type){
      chefForPartyService.revertCookDenial(trialId)
      .then((res) => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Cook Revereted Successfully",
          type: CustomSnackbarTypes.SUCCESS,
        });
        refreshData();
      })
      .catch((err) => {
        console.log(err);
      });
    }
    else{
      omsService
        .revertDeniedCook(trialId, cookId)
        .then((res) => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Cook Revereted Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
          refreshData();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const toggleDenialEmergencyStatus = useCallback((cancelId: number) => {
    const serviceCall = props?.type
      ? chefForPartyService.toggleDenialEmergencyStatus(cancelId)
      : omsService.toggleDenialEmergencyStatus(cancelId);

    serviceCall
      .then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Emergency status updated successfully",
          type: CustomSnackbarTypes.SUCCESS,
        });
        refreshData();
      })
      .catch((err) => {
        console.log(err);
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Failed to update emergency status",
          type: CustomSnackbarTypes.ERROR,
        });
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.type, props.serviceId]);

  const refreshData = useCallback(() => {
    if(props.type){
      chefForPartyService.getAllDenialsByPartyId(props.serviceId)
      .then((res) => {
        setDeniedCookSInOms(res);
      })
      .catch((err) => {
        console.log(err);
      });
    }
    else{
      omsService
        .getDeniedCooksForOneMeal(props.serviceId)
        .then((res) => {
          setDeniedCookSInOms(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [props.serviceId, props.type]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return (
    <div>
      {deniedCooksInOms.length === 0 ? (
        <EmptyListPlaceholder message="No Cooks Found" />
      ) : (
        <DeniedCooks
          cookData={deniedCooksInOms}
          callBack={revertDeniedCook}
          id={props.serviceId}
          refresh={refreshData}
          type={props.type}
          toggleEmergency={toggleDenialEmergencyStatus}
        />
      )}
    </div>
  );
};

export default OmsDeniedCookList;
